import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import PageHeader from "../../components/ui/PageHeader";
import ChartOfAccountsList from "../../components/accounting/ChartOfAccountsList";
import ChartOfAccountsForm from "../../components/accounting/ChartOfAccountsForm";

const ChartOfAccountsPage = () => {
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingAccount, setEditingAccount] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (account) => {
    setEditingAccount(account);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingAccount(null);
    setRefreshKey((k) => k + 1);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingAccount(null);
  };

  return (
    <Box>
      <PageHeader
        title="Plan de Cuentas"
        subtitle="Catálogo jerárquico de cuentas contables"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingAccount(null);
              setShowForm(true);
            }}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
            }}
          >
            Nueva Cuenta
          </Button>
        }
      />

      <ChartOfAccountsList key={refreshKey} onEdit={handleEdit} />

      <Dialog
        open={showForm}
        onClose={handleCloseForm}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: "24px" } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ChartOfAccountsForm
            account={editingAccount}
            onSave={handleSave}
            onCancel={handleCloseForm}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ChartOfAccountsPage;
